export const goTo = (url) => {
  return window.location.pathname = url;
}